import React from "react";
import Link from "next/link";

const Index = () => {
  return (
    <footer>
      <div className="container" style={{ display: "flex", flexWrap: "wrap" }}>
        <div className="col-12 col-lg-6">
          <p style={{ paddingTop: "20px" }} className="text-md-center text-lg-start">
            <a
              href="https://portal.ehawaii.gov/page/privacy-policy/"
              target="_blank"
            >
              Privacy Policy
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="https://dlnr.hawaii.gov/dofaw/" target="_blank">
              About Hawai&#699;i DOFAW
            </a>
          </p>
          <p className="text-md-center text-lg-start">
            Copyright &copy; {new Date().getFullYear()} Hawai'i DOFAW. All
            Rights Reserved.
          </p>
        </div>
        <div className="col-12 col-lg-6 text-center text-lg-end" style={{ paddingTop: "10px" }}>
          <p>
            <img src="/images/dofaw-dept-logo.png" className="footerLogo" alt="Hawaii DOFAW logo" />
            <img
              src="/images/Seal_of_the_State_of_Hawaii.svg"
              alt="Seal of the State of Hawaii"
              className="footerLogo stateSeal"
            />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Index;
